(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["accessories-product-iot"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accessories-product-powerbank"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["accessories-product"] && !Shopify.designMode) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-recommendations"] && !Shopify.designMode) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Detailed-description"] && !Shopify.designMode) return;
  try {
    
  function isMobile() {
  const { width } = window.screen;
  return width < 990; 
}
function setupObserver(selector) {
  const items = Array.from(document.querySelectorAll(selector));
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const index = items.indexOf(entry.target); 
          if (index !== -1) {
            setTimeout(() => {
              entry.target.classList.add('show');
            }, index * 240); 
          }
        }
      });
    },
    { threshold: 0.1 }
  );

  items.forEach((item) => {
    observer.observe(item);
  });
}

function initializeObservers() {
  if (window.innerWidth < 990) {
    // console.log('Initializing observer for mobile view');
    setupObserver('.Designed__container,.Thoughtful__grid__box__mobile');
  } else {
    setupObserver('.Thoughtful__container');
  }
}

window.onload = function () {
  initializeObservers();
};

window.addEventListener('resize', function () {
  initializeObservers();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
      constructor() {
        super();
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
          }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
          activeMedia.loadContent();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }
    
    hideAllPanel () {
      document.querySelectorAll('.tenways_top localization-form').forEach(element => {
        if (element !== this) {
          element.querySelector('.disclosure__list').setAttribute('hidden', true);
          element.querySelector('.disclosure__button').classList.remove('active-current');
        }
      })
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;
      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      this.elements.input.value = event.currentTarget.dataset.value;
      // if the value equals GB, redirect user to the uk.tenways.com store
      if (this.elements.input.value == 'GB') {
        location.href = '//uk.tenways.com'
      } else {
        event.preventDefault();
        const form = this.querySelector('form');
        if (form) form.submit(); 
      }
    }

    openSelector() {
      this.hideAllPanel();
      if(!(this.elements.panel.getAttribute('hidden') == "true") && this.elements.button.classList.contains('active-current')) {
        this.elements.button.classList.remove('active-current');
      } else {
        this.elements.button.classList.add('active-current');
      }
      
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

class NavigatorDisclosure extends HTMLElement {
  constructor() {
    super();
    this.navigator = this.querySelector('navigator');
    this.debounceTimeout = 100; 
    this.animationDuration = 500; 
    this.isAnimating = false;
    if (this.navigator) {
      this.navigator.addEventListener('click', this.onNavigatorClick.bind(this));
    }
    document.addEventListener('scroll', this.update.bind(this));
    document.querySelectorAll('.second_nav').forEach(
      (secondNav) => secondNav.addEventListener('click', this.onsecondNavClick.bind(this))
    );
  }
  onNavigatorClick(event) {
    if (this.isAnimating) return;
    const secondNav = this.querySelector('.second_nav');
    const currentLi = this.closest('li');
    document.querySelectorAll('navigator-disclosure').forEach(element => {
      if (element !== this) {
        element.classList.remove('active');
        const otherSecondNav = element.querySelector('.second_nav');
        if (otherSecondNav) {
          this.hideNav(otherSecondNav);
        }
        const otherLi = element.closest('li');
        if (otherLi) {
          otherLi.classList.remove('open');
        }
      }
    });
    if (secondNav.style.visibility === 'visible') {
      this.hideNav(secondNav);
      if (this.classList.contains('active')) {
        this.classList.remove('active');
      }
      if (currentLi && currentLi.classList.contains('open')) {
        currentLi.classList.remove('open');
      }
    } else {
      this.showNav(secondNav);
      if (!this.classList.contains('active')) {
        this.classList.add('active');
      }
      if (currentLi && !currentLi.classList.contains('open')) {
        currentLi.classList.add('open');
      }
    }
  }
  showNav(secondNav) {
    this.clearAnimations(secondNav);
    this.isAnimating = true;
    secondNav.style.visibility = 'visible';
    secondNav.style.opacity = 0;
    requestAnimationFrame(() => {
      secondNav.classList.add('transition');
      secondNav.style.opacity = 1;
      setTimeout(() => {
        this.isAnimating = false;
      }, this.animationDuration);
    });
    const childItems = Array.from(secondNav.children);
    childItems.forEach((element, index) => {
      this.clearAnimations(element);
      element.style.opacity = 0;
      requestAnimationFrame(() => {
        element.classList.add('transition');
        setTimeout(() => {
          element.style.opacity = 1;
        }, index * 100);
      });
    });
  }
  hideNav(secondNav) {
    this.clearAnimations(secondNav);
    this.isAnimating = true;
    secondNav.classList.add('transition');
    secondNav.style.opacity = 0;
    setTimeout(() => {
      secondNav.classList.remove('transition');
      secondNav.style.visibility = 'hidden';
      this.isAnimating = false;
    }, this.animationDuration);
    const childItems = Array.from(secondNav.children);
    childItems.forEach(element => {
      this.clearAnimations(element);
      element.classList.add('transition');
      element.style.opacity = 0;
    });
  }
  update() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 10) {
      document.querySelectorAll('.second_nav').forEach(secondNav => {
        this.hideNav(secondNav);
      });
      document.querySelectorAll('navigator-disclosure').forEach(element => {
        element.classList.remove('active');
      });
    }
  }
  
  onsecondNavClick(event) {
    event.stopPropagation();
  }
  clearAnimations(element) {
    element.classList.remove('transition');
    element.style.transition = 'none';
    requestAnimationFrame(() => {
      element.style.transition = '';
    });
  }
}

customElements.define('navigator-disclosure', NavigatorDisclosure);

Element.prototype.siblings = function() {
  if (!this.parentNode) return [];
  const children = Array.from(this.parentNode.children);
  return children.filter(child => child !== this);
};

document.addEventListener('click', function (e) {
  const target = e.target.closest('navigator');
  if (!target) {
    document.querySelectorAll('.second_nav').forEach(secondNav => {
      secondNav.style.visibility = 'hidden';
      secondNav.style.opacity = 0;
      secondNav.style.transform = 'translateY(-10px)';
    });
    document.querySelectorAll('navigator-disclosure').forEach(element => {
      element.classList.remove('active');
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Main-Introduction"] && !Shopify.designMode) return;
  try {
    

    document.addEventListener('DOMContentLoaded', function () {
    const IntegrateElements = document.querySelectorAll('.Integrate__container, .highlight__content');
    const observer = new IntersectionObserver(
      (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate'); 
            observer.unobserve(entry.target); 
          }
        });
      },
      {
        threshold: 0.3,
      }
    );

    IntegrateElements.forEach((element) => observer.observe(element));
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
          element.classList.remove('active');
        }
      )
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
      const activeMediaTemplate = activeMedia.querySelector('template');
      const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
      activeMedia.classList.add('active');
      activeMedia.scrollIntoView();

      const container = this.querySelector('[role="document"]');
      container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
        activeMedia.loadContent();
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["Perfectly-balanced-details"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const captionElementsDesktop = document.querySelectorAll('.container-full-screen');
    const captionElementsMobile = document.querySelectorAll('.details__grid, .Perfectly_mobile_heading');
    const observerOptions = {
      threshold: 0.2,
    };
    const handleIntersect = (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('float_up');
          observer.unobserve(entry.target);
        }
      });
    };
    const setupObserver = (elements) => {
      if (elements.length === 0) return;
      const observer = new IntersectionObserver(handleIntersect, observerOptions);
      elements.forEach((element) => observer.observe(element));
    };
    const initObservers = () => {
      if (window.innerWidth > 990) {
        setupObserver(captionElementsDesktop);
      } else {
        setupObserver(captionElementsMobile);
      }
    };

    initObservers();
    window.addEventListener('resize', () => {
      initObservers();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["selling-point-video"] && !Shopify.designMode) return;
  try {
    
    const videoItems = Array.from(document.querySelectorAll('.sell_point_video_item'));
    const svgItems = Array.from(document.querySelectorAll('.sell_point_svg_item'));
  
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const isMobile = window.innerWidth <= 900;
            
            if (svgItems.includes(entry.target)) {
              if (isMobile) {
                entry.target.classList.add('show_item_');
              } else {
                const index = svgItems.indexOf(entry.target);
                setTimeout(() => {
                  entry.target.classList.add('show_item_');
                }, index * 120);
              }
            } else if (videoItems.includes(entry.target)) {
              entry.target.classList.add('show_item_');
            }
          }
        });
      },
      { threshold: 0 }
    );
  
    videoItems.forEach((item) => {
      observer.observe(item);
    });
  
    svgItems.forEach((item) => {
      observer.observe(item);
    });
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tenways-app"] && !Shopify.designMode) return;
  try {
    
$(document).ready(function () {
  function getScreenWidth() {
    return $(window).width();
  }

  function initDesktop() {
    const screenWidth = getScreenWidth();
    if (screenWidth <= 900) return;
    const desktopContainer = $('.app-features__content--desktop');
    if (desktopContainer.length === 0) return;

    const videoContainers = desktopContainer.find('.app-features__item-video-background');
    const videos = videoContainers.map(function () {
      return $(this).find('video')[0];
    }).get();
    
    let currentVideoIndex = 0;
    let hasStartedPlaying = false;
    let isInitialPlayComplete = false;

    function updateButtonState(activeIndex) {
      videos.forEach(function (_, index) {
        const playBtn = $(`#play-button-${index}`);
        const pauseBtn = $(`#pause-button-${index}`);
        if (playBtn.length && pauseBtn.length) {
          if (index === activeIndex) {
            playBtn.hide();
            pauseBtn.show();
          } else {
            playBtn.show();
            pauseBtn.hide();
          }
        }
      });
    }

    function handlePlayVideo(index) {
      if (videos[currentVideoIndex] && currentVideoIndex !== index) {
        videos[currentVideoIndex].pause();
      }
      currentVideoIndex = index;
      const video = videos[currentVideoIndex];
      if (!video) return;

      if (video.ended) {
        video.currentTime = 0;
      }

      video.play().catch(() => {});
      updateButtonState(currentVideoIndex);
      $(video).off('ended').on('ended', function () {
        updateButtonState(-1);
        if (!isInitialPlayComplete) {
          currentVideoIndex++;
          if (currentVideoIndex < videos.length) {
            playNextVideo();
          } else {
            isInitialPlayComplete = true;
            currentVideoIndex = 0;
          }
        }
      });
    }

    function playNextVideo() {
      const video = videos[currentVideoIndex];
      if (!video) return;
      video.currentTime = 0;
      video.play().catch(() => {});
      updateButtonState(currentVideoIndex);
      $(video).off('ended').on('ended', function () {
        updateButtonState(-1);
        if (!isInitialPlayComplete) {
          currentVideoIndex++;
          if (currentVideoIndex < videos.length) {
            playNextVideo();
          } else {
            isInitialPlayComplete = true;
            currentVideoIndex = 0;
          }
        }
      });
    }

    window.playVideo = handlePlayVideo;
    window.pauseVideo = function (index) {
      if (videos[index]) {
        videos[index].pause();
        updateButtonState(-1);
      }
    };

    function startObserver() {
      if (!('IntersectionObserver' in window)) {
        hasStartedPlaying = true;
        playNextVideo();
        return;
      }
      const observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && !hasStartedPlaying) {
              hasStartedPlaying = true;
              playNextVideo();
              observer.unobserve(desktopContainer[0]);
            }
          });
        },
        { threshold: 0.5 }
      );
      observer.observe(desktopContainer[0]);
    }

    startObserver();
  }

  function initMobile() {
    const screenWidth = getScreenWidth();
    if (screenWidth > 900) return;
    const mobileContainer = $('.app-features__content--mobile');
    if (mobileContainer.length === 0) return;

    const mobileSwiper = new Swiper('.swiper-container.app-features__content--mobile', {
      slidesPerView: 1.05,
      spaceBetween: 14,
      navigation: {
        nextEl: '.app-features-next.swiper-button-next',
        prevEl: '.app-features-prev.swiper-button-prev',
      },
      pagination: {
        el: '.swiper-pagination-progressbar-fill',
        bulletElement: 'li',
      },
      on: {
        slideChange: debounce(function () {
          const newIndex = this.activeIndex;
          playMobileVideoOnSlide(newIndex);
        }, 200)
      }
    });

    const mobileVideoContainers = mobileContainer.find('.swiper-slide .app-features__item-video-background-mobile');
    let mobileVideoElements = [];
    let mobileCurrentVideoIndex = -1;
    function updateMobileButtonState(index, isPlaying) {
      const playBtn = $(`#mobile-play-button-${index}`);
      const pauseBtn = $(`#mobile-pause-button-${index}`);
      if (playBtn.length && pauseBtn.length) {
        if (isPlaying) {
          playBtn.hide();
          pauseBtn.show();
        } else {
          playBtn.show();
          pauseBtn.hide();
        }
      }
    }

    function playMobileVideoOnSlide(index) {
      if (mobileCurrentVideoIndex !== -1 && mobileCurrentVideoIndex !== index) {
        pauseMobileVideo(mobileCurrentVideoIndex);
      }
      const video = mobileVideoElements[index];
      if (!video) return;
      if (video.ended) {
        video.currentTime = 0;
      }

      updateMobileButtonState(index, true);
      video.play().catch(() => {});
      mobileCurrentVideoIndex = index;
      $(video).off('ended').on('ended', function () {
        updateMobileButtonState(index, false);
      });
    }

    function pauseMobileVideo(index, { reset = false } = {}) {
      const video = mobileVideoElements[index];
      if (!video) return;
      video.pause();
      if (reset) {
        video.currentTime = 0;
      }
      updateMobileButtonState(index, false);
    }

    function setupMobileVideoListeners(video, index) {
      const playBtn = $(`#mobile-play-button-${index}`);
      const pauseBtn = $(`#mobile-pause-button-${index}`);

      if (playBtn.length) {
        playBtn.off('click').on('click', function () {
          playMobileVideoOnSlide(index);
        });
      }
      if (pauseBtn.length) {
        pauseBtn.off('click').on('click', function () {
          pauseMobileVideo(index);
        });
      }
      $(video).off('ended').on('ended', function () {
        updateMobileButtonState(index, false);
      });
    }

    mobileVideoContainers.each(function (index, container) {
      const video = $(container).find('video')[0];
      if (video) {
        mobileVideoElements.push(video);
        setupMobileVideoListeners(video, index);
      }
    });

    window.playVideo = function (index) {
      playMobileVideoOnSlide(index);
    };
    window.pauseVideo = function (index) {
      pauseMobileVideo(index);
    };
  }

  function debounce(func, delay) {
    let inDebounce;
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(inDebounce);
      inDebounce = setTimeout(() => func.apply(context, args), delay);
    };
  }

  initDesktop();
  initMobile();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-600pro"] && !Shopify.designMode) return;
  try {
    
  const videoItems = Array.from(document.querySelectorAll('.video_item'));
  const svgItems = Array.from(document.querySelectorAll('._svg_item'));

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          // 检查是否为移动端
          const isMobile = window.innerWidth <= 900;

          if (svgItems.includes(entry.target)) {
            if (isMobile) {
              // 移动端直接显示，不添加延迟
              entry.target.classList.add('show');
            } else {
              // 非移动端保持原有的延迟效果
              const index = svgItems.indexOf(entry.target);
              setTimeout(() => {
                entry.target.classList.add('show');
              }, index * 120);
            }
          } else if (videoItems.includes(entry.target)) {
            entry.target.classList.add('show');
          }
        }
      });
    },
    { threshold: 0.1 }
  );

  videoItems.forEach((item) => {
    observer.observe(item);
  });

  svgItems.forEach((item) => {
    observer.observe(item);
  });

  } catch(e) { console.error(e); }
})();
})();
